/**
 * Model is the base class for all domain models (strict OOP).
 * A Model owns its data and its validation invariants. Subclasses implement
 * `validate()` returning human-readable errors (empty = valid).
 */
export class Model {
    isValid() {
        return this.validate().length === 0;
    }
    assertValid() {
        const errors = this.validate();
        if (errors.length > 0) {
            throw new Error(`Invalid ${this.constructor.name}: ${errors.join("; ")}`);
        }
    }
}
//# sourceMappingURL=Model.js.map